import { render, staticRenderFns } from "./iphoneYearChange.vue?vue&type=template&id=610ef206&scoped=true&"
import script from "./iphoneYearChange.vue?vue&type=script&lang=js&"
export * from "./iphoneYearChange.vue?vue&type=script&lang=js&"
import style0 from "./iphoneYearChange.vue?vue&type=style&index=0&id=610ef206&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ef206",
  null
  
)

export default component.exports